/**
 * @file contains link names for route hashing
 */

export const HASH_MESSAGE__INFO__ATTACHMENT = 'attachments';
export const HASH_MESSAGE__INFO__ASSIGNEE = 'assignees';
export const HASH_MESSAGE__INFO__CHECKLIST = 'checklist';
export const HASH_MESSAGE__INFO__STATUS = 'status';
export const HASH_MESSAGE__INFO__DUE_DATE = 'date';
